/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
// Create "window.Shoppad.apps.infiniteoptions" object if it doesn't already exist.
"Shoppad.apps.infiniteoptions".split(".").reduce(function(o, x) { if (!o[x]) {o[x] ={};} return o[x] }, window);

// Make changes once the app has been loaded.
window.Shoppad.apps.infiniteoptions.beforeReady = function(subscribe) {
    subscribe('appLoad', function(event) {
        const fields = event.detail.fields;

        /*  Update specific fields when they are present. */
        for (let i = 0; i < fields.length; i++ )
            for (let j = 0; j < fields[i].length; j++ )
            {
                /* Update the gift wrap option text */
                // Make the text bold and maybe add, not in bold, 'Free!' to the end.
                if ( fields[i][j].class.includes('jp-io-cb') && fields[i][j].class.includes('jp-gift-wrap-option') ) {
                    let boldE = document.createElement('b');
                    const boldETextNode = document.createTextNode(
                        document.querySelectorAll(".jp-io-cb.jp-gift-wrap-option fieldset label")[0].childNodes[1].data
                    );
                    boldE.appendChild(boldETextNode);

                    let parentDiv = document.createElement('div');
                    parentDiv.style.display = 'inline-block';
                    parentDiv.appendChild(boldE);

                    if ( fields[i][j].class.includes('jp-add-free') ) {
                        boldE.style.marginRight = "10px";
                        let spanE = document.createElement('span');
                        const spanETextNode = document.createTextNode("Free!");
                        spanE.appendChild(spanETextNode);
                        boldE.after(spanE);
                    }
                    document.querySelectorAll(".jp-io-cb.jp-gift-wrap-option fieldset label")[0].childNodes[1].replaceWith(parentDiv);
                }
                if ( fields[i][j].class.includes('jp-io-cb') && fields[i][j].class.includes('jp-personalize-option') ) {
                    let personalizeTooltipElement = document.querySelectorAll(".jp-io-cb.jp-personalize-option .spb-tooltip")[0];
                    if ( ! personalizeTooltipElement ) {
                        console.warn("Possible Error detected!  Personalization checkbox option is lacking tooltip.");
                    } else
                    if ( 3 === personalizeTooltipElement.childNodes.length ) {
                        // Remove the info icon
                        personalizeTooltipElement.childNodes[1].remove();
                        // Remove io tooltip styles
                        personalizeTooltipElement.children[1].classList.remove('spb-tooltiptext');
                        // Add the jp tooltip styles
                        personalizeTooltipElement.children[1].classList.add('jp-io-tooltip');
                    } else {
                        console.error("Error detected!  Only one Personilize Option checkbox field is allowed per product page.  Please verify the options setup.");
                    }
                }
            }
    });
};

// Reset the min-height of the product info wrapper using a mutation observer.
// Select the node that will be observed for mutations.
const targetNode = document.getElementById('infiniteoptions-container');
// Options for the observer (which mutations to observe).
const config = { childList: true, attributes: true, subtree: true };
// Callback function to execute when mutations are observed.
const resetHeight = function(mutationsList, observer) {
    // Use traditional 'for loops' for IE 11
    for(const mutation of mutationsList) {
        const productInfoElement        = document.querySelector('.product-block-list__item--info .card');
        const productInfoElementWrapper = document.querySelector('.product-block-list__wrapper');
        if ( productInfoElement && productInfoElementWrapper ) {
            if ( productInfoElementWrapper.style.minHeight !== productInfoElement.clientHeight + 'px' ) {
                document.querySelector('.product-block-list__wrapper').style.minHeight = productInfoElement.clientHeight + 'px';
                // changes are done, stop observing.
                observer.disconnect();
            }
        }
    }
};

// Create an observer instance linked to the callback function.
const heightObserver = new MutationObserver(resetHeight);

// Start observing the target node for configured mutations.
heightObserver.observe(targetNode, config);

